import {ErrorResponsesType} from '../types'

export const retryInsufficientFunds = (failureCount: number, error: ErrorResponsesType) =>
  !(error.error === 'insufficient_funds' || failureCount >= 3)
